export default {
	SEND_MESSAGE: 'companies/:company_id/contacts/send-message',
	MULTIPLE_DELIVERY : 'companies/:company_id/contacts/bulk-send-communications',
	CONTACTS: 'companies/:company_id/contacts/',
	CONTACTS_OMNI: 'companies/:company_id/contacts/omni-search',
	TRANSACTION_HISTORY: 'companies/:company_id/transaction',
	DOWNLOAD_TRANSACTION_HISTORY: 'companies/:company_id/transaction/download-xlsx',
	SEND_SHORTEN_LINK : 'companies/:company_id/uploads/send-shorten-link'
}
